// extracted by mini-css-extract-plugin
export default {"row":"qeU01R_kx4NPzCk3gkBu"};